<template>
  <van-search
    v-model="searchValue"
    shape="round"
    placeholder="编号"
    @search="onSearch"
    @cancel="onLoad"
    class="search-bar"
  />
  <van-list
    v-model:loading="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <van-cell-group
      v-for="(item, index) in candidates"
      :key="index"
      :thumb="item.image"
    >
      <van-cell>
        <div class="cell-content">
          <van-image
            class="image"
            width="100%"
            height="200"
            fit="contain"
            :src="item.image"
            @click="imgClick(item, index)"
            @click.stop
          />
          <div class="card-title">
            编号{{ item.code }}：{{ item.title }}（{{ item.name }} 摄）
          </div>
          <div class="card-desc">{{ item.description }}</div>
          <div class="vote-btn-left">
            <div>拍摄地点：{{ item.address }}</div>
          </div>
          <div class="vote-btn">
            <div class="vote-btn-left">
              <!-- <div>{{ item.address }}</div> -->
              <div>拍摄时间：{{ item.shoottime }}</div>
            </div>
            <van-stepper
              class="stepper"
              v-model="item.my_vote"
              :name="item.id"
              theme="round"
              button-size="24"
              disable-input
              :disable-plus="leftVoteNum === 0 ? true : false"
              min="0"
              :max="maxNum"
              :step="maxNum"
              default-value="0"
              @plus="onPlus()"
              @minus="onMinus()"
              @click.stop
            />
            <!-- :max="calMax(item.my_vote)" -->
          </div>
        </div>
      </van-cell>
    </van-cell-group>
  </van-list>
  <div class="list-bottom"></div>
</template>

<script>
import {
  List,
  Card,
  Button,
  Search,
  Checkbox,
  CheckboxGroup,
  Toast,
  Stepper,
  Cell,
  CellGroup,
  Grid,
  GridItem,
  Image as VanImage,
  ImagePreview,
} from "vant";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  name: "NumList",
  components: {
    [VanImage.name]: VanImage,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [List.name]: List,
    [Card.name]: Card,
    [Button.name]: Button,
    [Search.name]: Search,
    [Checkbox.name]: Checkbox,
    [Stepper.name]: Stepper,
    [CheckboxGroup.name]: CheckboxGroup,
    [Toast.name]: Toast,
  },
  setup() {
    const searchValue = ref("");
    const loading = ref(false);
    const finished = ref(false);
    // let { ctx } = getCurrentInstance();
    const route = useRoute();

    const store = useStore();

    const onLoad = () => {
      if (route.query.id) {
        console.log("4有没有id", store.state.termId);
        store.state.termId = Number(route.query.id);
        let params = {
          term_id: store.state.termId,
        };

        store.dispatch("getAppEnv", { params }).then(() => {
          store.dispatch("getCanVote", { params });
          store.dispatch("getCandidates", { params, loading, finished });
        });
      } else {
        store.dispatch("getAppEnv", {}).then(() => {
          let id = store.state.termId;
          let params = {
            term_id: id,
          };

          store.dispatch("getCanVote", { params });
          store.dispatch("getCandidates", { params, loading, finished });
        });
      }

      // const params = { term_id: 1 };
      // store.dispatch("getLeftVote");
    };

    const onSearch = (val) => {
      const params = { search: val, term_id: store.state.termId };
      store.dispatch("getCandidates", { params, loading, finished });
      // store.dispatch("getLeftVote");
    };

    // const handleClick = (url) => {
    //   const v = new RegExp(
    //     "^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$",
    //     "i"
    //   );
    //   if (v.test(url)) {
    //     window.open(url, "_blank");
    //   }
    // };

    const imgClick = (item, index) => {
      console.log(Array(item.image), index);
      ImagePreview({
        images: Array(item.image),
        closeable: true,
      });
    };

    const calMax = (curVote) => {
      return store.state.leftVoteNum + curVote;
    };

    const onPlus = () => {
      store.commit("plusLeftVoteNum");
    };

    const onMinus = () => {
      store.commit("minusLeftVoteNum");
    };

    return {
      searchValue,
      onSearch,
      onLoad,
      loading,
      finished,
      // max: computed(() => store.state.leftVoteNum),
      calMax,
      candidates: computed(() => store.state.candidates),
      // handleClick,
      onPlus,
      onMinus,
      imgClick,
      leftVoteNum: computed(() => store.state.leftVoteNum),
      maxNum: computed(() => store.state.maxNum),
    };
  },
  created() {
    const { aplus_queue } = window;
    aplus_queue.push({
      action: "aplus.sendPV",
      arguments: [
        {
          is_auto: false,
        },
        {
          param: "numlist",
        },
      ],
    });
  },

  computed: {
    checked: {
      get() {
        return this.$store.state.checked;
      },
      set(value) {
        this.$store.commit("updateChecked", value);
      },
    },
  },
};
</script>

<style lang="scss" src="./numlist.scss" scoped></style>
